// extracted by mini-css-extract-plugin
export default {"body":"body__body__D8kMP"};